export default __webpack_public_path__ + "static/bg-nellie-2b0662dbb7c192b647b75cf371d7a737.png";